import React from 'react';
import CommandOutput from './CommandOutput';

class CommandError extends CommandOutput {
  constructor(error, backtrace) {
    super();
    this.error = error;
    this.backtrace = backtrace;
  }

  render() {
    return (
      <div className='command__result--error'>
        <div className='command__error-name'>
          <i className='fa-regular fa-exclamation-triangle' />
          &nbsp;
          {this.error}
        </div>
        <pre className='command__error-stack'>{this.backtrace}</pre>
      </div>
    );
  }
}

export default CommandError;
